<button csButton type="button" class="tw-w-full"
  [disabled]="disabled()"
  [loading]="loading()"
  (click)="onClick()">
  <span class="tw-flex tw-items-center tw-justify-center tw-gap-2">
    <span>{{ label() }}</span>
    @if (icon()) {
      <em [class]="icon()"></em>
    }
  </span>
</button>
